<template>
<div>
    <l-map
        :zoom='zoom'
        :center='center'
        style='height: 200px; width: 100%;'>
        <l-marker :lat-lng='center' :icon='customIcon'></l-marker>
        <l-tile-layer :url='url' :attribution='attribution'></l-tile-layer>
    </l-map>
</div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker } from '@vue-leaflet/vue-leaflet';
import '@/static/css/leaflet.css';

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
    },
})
export default class MapComponent extends Vue {
    @Prop({ type: Number, required: true }) readonly latitude!: number;
    @Prop({ type: Number, required: true }) readonly longitude!: number;
    @Prop({ default: 14 }) zoom!: number;
    @Prop({ default: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' }) url!: string;
    @Prop({ default: '© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' }) attribution!: string;

    customIcon = null;

    get center() {
        return [this.latitude, this.longitude];
    }

    created() {
        // @ts-ignore-next-line
        this.customIcon = L.icon({
            iconUrl: this.requireImage('marker.svg'),
            iconSize: [50, 50],
        });
    }
}
</script>

<style src="./leaflet.css"></style>
